<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select v-model="filters.city" filterable clearable placeholder="城市（可搜索）" size="mini" @change="onCityChange">
          <el-option v-for="item in cityOptions" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="shaixuan-item project-multi">
        <el-select
          v-model="filters.community_ids"
          multiple
          filterable
          reserve-keyword
          collapse-tags
          clearable
          placeholder="筛选小区（可搜索）"
          size="mini"
        >
          <el-option v-for="item in projectSelectOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" @click="resetFilters">重置</el-button>
        <el-button size="mini" icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出 Excel</el-button>
      </div>
    </div>
    <div v-loading="listLoading" class="common-section-bg common-section-body table-wrap">
      <el-table :data="tableData" size="mini" show-summary :summary-method="getSummaries" style="width: 100%; min-height: 300px" class="stats-table">
        <el-table-column prop="city" label="城市" min-width="70" />
        <el-table-column prop="project" label="项目" min-width="120" show-overflow-tooltip />
        <el-table-column prop="total_spaces" label="车位总数" min-width="90" align="center" />
        <el-table-column prop="unsold_spaces" label="待售" min-width="80" align="center" />
        <el-table-column prop="sold_spaces" label="已售" min-width="80" align="center" />
        <el-table-column prop="normal_spaces" label="正常车位" min-width="90" align="center" />
        <el-table-column prop="normal_vehicles" label="正常车辆" min-width="90" align="center" />
        <el-table-column prop="delayed_spaces" label="延期车位" min-width="90" align="center" />
        <el-table-column prop="delayed_vehicles" label="延期车辆" min-width="90" align="center" />
        <el-table-column prop="special_vehicles" label="特殊车辆" min-width="90" align="center" />
      </el-table>
      <p class="tip-text">
        统计范围：已配置海康/捷卫士车场的小区；车辆为海康+捷卫士合并；车位含 CW/CK。
        待售=天问交付状态 1/2/3；已售=状态 4 及以上；延期车位=绑定延期车辆的车位；正常车位=已售−延期车位。
      </p>
    </div>
  </div>
</template>

<script>
import chechangReportStatistics from '@/api/tianzheng/chechangReportStatistics'

const defaultFilters = () => ({
  city: '',
  community_ids: []
})

export default {
  name: 'DataStatistics',
  data() {
    return {
      listLoading: false,
      exportLoading: false,
      communityOptions: [],
      cityOptions: [],
      tableData: [],
      filters: defaultFilters()
    }
  },
  computed: {
    projectSelectOptions() {
      if (!this.filters.city) return this.communityOptions
      return this.communityOptions.filter(item => item.city === this.filters.city)
    }
  },
  created() {
    this.loadCommunityOptions()
    this.getList()
  },
  methods: {
    loadCommunityOptions() {
      chechangReportStatistics.communitySelect().then(res => {
        if (res.code === 200) {
          this.communityOptions = res.result || []
          this.cityOptions = [...new Set(this.communityOptions.map(i => i.city).filter(Boolean))]
        }
      })
    },
    buildParams() {
      const params = {}
      if (this.filters.city) params.city = this.filters.city
      if (this.filters.community_ids && this.filters.community_ids.length) {
        params.community_ids = this.filters.community_ids.join(',')
      }
      return params
    },
    getList() {
      this.listLoading = true
      chechangReportStatistics.list(this.buildParams()).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.tableData = res.result.list || []
        }
      }).catch(() => { this.listLoading = false })
    },
    handleSearch() {
      this.getList()
    },
    onCityChange() {
      if (!this.filters.community_ids.length) return
      const allowed = new Set(this.projectSelectOptions.map(i => i.id))
      this.filters.community_ids = this.filters.community_ids.filter(id => allowed.has(id))
    },
    resetFilters() {
      this.filters = defaultFilters()
      this.getList()
    },
    getSummaries({ columns }) {
      const sums = []
      const sumKeys = ['total_spaces', 'unsold_spaces', 'sold_spaces', 'normal_spaces', 'normal_vehicles', 'delayed_spaces', 'delayed_vehicles', 'special_vehicles']
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = ''
          return
        }
        if (sumKeys.includes(column.property)) {
          sums[index] = this.tableData.reduce((acc, row) => acc + (Number(row[column.property]) || 0), 0)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    handleExport() {
      this.exportLoading = true
      chechangReportStatistics.export(this.buildParams()).then(res => {
        this.exportLoading = false
        if (res.code === 200 && res.result && res.result.url) {
          window.open(res.result.url)
        } else {
          this.$message.error(res.msg || '导出失败')
        }
      }).catch(() => { this.exportLoading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';

.project-multi {
  min-width: 260px;
  ::v-deep .el-select {
    width: 260px;
  }
}

.tip-text {
  margin: 12px 0 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
</style>
